import React from 'react'
import { connect } from 'react-redux'
import CategoryActions from '../../Redux/CategoryRedux'

class UpdateCategory extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        name: props.detail.name || '',
        id: props.detail.id || ''
      }
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value
    let form = {...this.state.form}
    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.form}
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.updateCategory(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Category Name</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Edit Category Name</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Category name'
                className='form-control'
                value={this.state.form.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
})

const dispatchToProps = (dispatch) => ({
  updateCategory: (data) => dispatch(CategoryActions.updateCategoryRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateCategory)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/UpdateCategoryName.js